import { Route } from '@angular/router';

export const sharedRoutes: Route[] = [
  /* { path: '', pathMatch: 'full', component: InsertYourComponentHere } */
];
